import { render, staticRenderFns } from "./PricingSideMenu.vue?vue&type=template&id=6311e096&"
import script from "./PricingSideMenu.vue?vue&type=script&lang=js&"
export * from "./PricingSideMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports